import { z } from 'zod'

const SelectOptionFormEntitySchema = z.object({
  id: z.string(),
  entityId: z.string().optional(),
  name: z.string().max(100),
  annotation: z.string().optional(),
  isPaid: z.boolean(),
  fileBase64: z.string().optional(),
  fileUrl: z.string().optional(),
  fileName: z.string().optional(),
  priority: z.number().optional(),
  isRemoveFile: z.boolean().optional(),
})

export const SelectMasterFormEntitySchema = z
  .object({
    entityId: z.string().optional(),
    displayName: z.string().max(100),
    name: z.string().max(100),
    description: z.string().optional(),
    modelRoomInfo: z.string().optional(),
    annotation: z.string().optional(),
    isRemoveFile: z.boolean().optional(),
    priority: z.number(),
    fileBase64: z.string().optional(),
    fileUrl: z.string().optional(),
    fileName: z.string().optional(),
    isDeleted: z.boolean().optional(),
    isPlanSelect: z.boolean(),
    options: z.array(
      SelectOptionFormEntitySchema.extend({
        children: z.array(SelectOptionFormEntitySchema),
      })
    ),
    roomIds: z.array(z.number()),
  })
  .superRefine((value, context) => {
    // isDeleted が false （削除対象ではない）の場合、displayName, name, options.name, option.children.name が全て必須
    if (
      !value.isDeleted &&
      (!value.displayName ||
        !value.name ||
        !value.options.some(option => !!option.name) ||
        value.options.some(option => option.children.some(child => !child.name)))
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: '必須項目を入力してください。',
        path: context.path,
      })
    }
  })

export const BulkUpdateSelectMasterFormEntitySchema = z.object({
  items: z.array(SelectMasterFormEntitySchema),
})

export type WriteSelectMasterFormEntity = z.infer<typeof SelectMasterFormEntitySchema>
export type BulkUpdateSelectMasterFormEntity = z.infer<
  typeof BulkUpdateSelectMasterFormEntitySchema
>
